import React, { useState } from 'react'
import styled from 'styled-components'
import typography from '../../../utils/typography'
import { Flex } from 'rebass'
import ContentDealershipLocationCard from '../../../components/ContentDealershipLocationCard'
import { graphql, useStaticQuery } from 'gatsby'
import { rem } from 'polished'

const FlexWrapper = styled(Flex)`
  justify-content: center;
  max-width: ${(props) => props.theme.content.max.width};
`

const MakeWrapper = styled(Flex)`
  width: 100%;
  max-width: 1134px;
  overflow-x: auto;
  &::-webkit-scrollbar {
    display: none;
  }
  border-bottom: 2px ${(props) => props.theme.colors.grey_light_op65} solid;
  padding: 0 0 0 18px;
  white-space: nowrap;

  @media screen and (min-width: 800px) {
    padding: 0 18px;
    justify-content: space-between;
    display: flex;
  }

  @media screen and (min-width: 1170px) {
    padding: 0;
  }
`

const MakeItem = styled.span`
  text-align: center;
  display: inline-block;
  margin-right: 18px;

  @media screen and (min-width: 800px) {
    margin-right: 0;
  }

  button {
    cursor: pointer;
    background: none;
    border: 0;
    text-transform: uppercase;
    font-size: ${rem('14.5px')};
    font-weight: 600;
    letter-spacing: 0.12em;
    color: ${(props) => props.theme.colors.grey_light_op65};
    padding: 9px 0;
    transition: color 0.3s ${(props) => props.theme.ease.ease_out_expo};
    background-color: 0.3s ${(props) => props.theme.ease.ease_out_expo};
  }

  &:hover button {
    opacity: 1;
    color: ${(props) => props.theme.colors.grey_op80};
  }

  button.active {
    color: ${(props) => props.theme.colors.blue};
    background-color: ${(props) => props.theme.colors.blue_mid_op10};
    opacity: 1;
  }
`

const AllDealerships = ({ locations }) => {
  const data = useStaticQuery(graphql`
    {
      allMakeCatfish {
        edges {
          node {
            id: _id
            name
            slug
            order
          }
        }
      }
    }
  `)

  const makes =
    data.allMakeCatfish &&
    data.allMakeCatfish.edges
      .map(({ node }) => node)
      .sort((a, b) => a.order - b.order)

  const [selection, setSelection] = useState(null)

  const formatSelection = (selection) => {
    if (selection === 'ŠKODA') return 'skoda'
    if (selection === 'Škoda') return 'skoda'
    if (selection === 'Volkswagen Commercial Vehicles') return 'vw-commercial'
    if (selection === 'GWM ORA') return 'gwm'
    if (selection === 'GWM') return 'gwm'

    return selection.toLowerCase()
  }

  const formatName = (name) => {
    if (name === 'Volkswagen Commercial Vehicles') return 'Volkswagen Vans'
    return name
  }

  return (
    <>
      <MakeWrapper
        mx={'auto'}
        flexWrap="nowrap"
        mt={[typography.rhythm(1), typography.rhythm(2), typography.rhythm(3)]}
      >
        <MakeItem>
          <button
            className={!selection && 'active'}
            onClick={() => setSelection(null)}
          >
            All
          </button>
        </MakeItem>
        {makes.map((make) => {
          return (
            <MakeItem key={make.id}>
              <button
                className={selection === make.name && 'active'}
                onClick={() => setSelection(make.name)}
              >
                {formatName(make.name)}
              </button>
            </MakeItem>
          )
        })}
      </MakeWrapper>

      <FlexWrapper
        mx={'auto'}
        pb={[typography.rhythm(1), typography.rhythm(2), typography.rhythm(3)]}
        flexWrap="wrap"
      >
        {locations.map((dealership) => {
          return (
            <>
              {dealership.vehicles.map((vehicle, i) => {
                if (!selection)
                  return (
                    <ContentDealershipLocationCard
                      key={`${dealership.shortName}:${vehicle}:${i}`}
                      dealership={dealership}
                    />
                  )

                const formattedSelection = formatSelection(selection)
                if (vehicle.slug === formattedSelection) {
                  return (
                    <ContentDealershipLocationCard
                      key={`${dealership.shortName}:${vehicle}`}
                      dealership={dealership}
                    />
                  )
                }
              })}
            </>
          )
        })}
      </FlexWrapper>
    </>
  )
}

export default AllDealerships
